import { httpClient } from "@/lib/http-client/http-client";
import { API_ROUTES } from "@/shared/constants/api.routes";
import {
  ISpecificationSupplierProductsRequest,
  ISupplierResponsesAllRequest,
} from "../interface/requests/ISupplierResponsesAllRequest";
import {
  ISupplierResponsesAllItem,
  ISpecificationSupplierProductsResponse,
} from "../interface/responses/ISupplierResponsesAllResponse";
import {
  IBaseListResponse,
  IBaseResponse,
} from "../interface/responses/IBaseResponse";

class SupplierResponsesAllService {
  constructor() {}

  async getSupplierResponsesAll(
    request: ISupplierResponsesAllRequest
  ): Promise<IBaseListResponse<ISupplierResponsesAllItem[]>> {
    const {
      companyId,
      offset = 0,
      limit = 20,
      search,
      sortBy,
      sortOrder,
    } = request;

    let queryParams =
      `?offset=${offset}&limit=${limit}` +
      (search ? `&search=${search}` : "") +
      (sortBy ? `&sortBy=${sortBy}` : "") +
      (sortOrder ? `&sortOrder=${sortOrder}` : "");

    const response = await httpClient.get<ISupplierResponsesAllItem[]>(
      API_ROUTES.SpecificationSupplierResponses.list(companyId) + queryParams
    );

    return response as IBaseListResponse<ISupplierResponsesAllItem[]>;
  }

  async getSpecificationProducts(
    request: ISpecificationSupplierProductsRequest
  ): Promise<ISpecificationSupplierProductsResponse> {
    const { specificationId, limit = 10, offset = 0 } = request;
    const queryParams = `?limit=${limit}&offset=${offset}`;

    const response =
      await httpClient.get<ISpecificationSupplierProductsResponse>(
        API_ROUTES.SpecificationSupplierResponses.products(specificationId) +
          queryParams
      );

    // API returns unwrapped response directly (no IBaseResponse wrapper)
    return response as unknown as ISpecificationSupplierProductsResponse;
  }
}

export const supplierResponsesAllService = new SupplierResponsesAllService();
